export default "__VITE_ASSET__BCagTMvD__"